import { c as _c } from "react/compiler-runtime";
// hooks/useSelectedToken.ts
import { selectedNftAtom, selectedTokenAtom } from "@/config/atoms/portfolio/selected";
import { useAtom } from "jotai";
export const useSelectedToken = () => {
  const $ = _c(5);
  const [selectedToken, setSelectedToken] = useAtom(selectedTokenAtom);
  const [selectedNft, setSelectedNft] = useAtom(selectedNftAtom);
  let t0;
  if ($[0] !== selectedNft || $[1] !== selectedToken || $[2] !== setSelectedNft || $[3] !== setSelectedToken) {
    t0 = {
      selectedToken,
      setSelectedToken,
      selectedNft,
      setSelectedNft
    };
    $[0] = selectedNft;
    $[1] = selectedToken;
    $[2] = setSelectedNft;
    $[3] = setSelectedToken;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
};